module.exports = __webpack_public_path__ + "img/sun.630fc021.svg";